export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4097006c20c88e7ada8af992b36f27c953dcefa6b9&name=revalidateCommunity!'